import React from 'react';

import areaValidator from '../area/areaValidator';
import EditForm from './EditForm';
import FormLoader from '../shared/forms/FormLoader';
import PropTypes from 'prop-types';

const JobEditor = ({
    editId,
    customerId,
    proposalId,
    cancelEdit,
    fetchData,
    scheduleOverride
}) => {
    const getUrl = `/api/jobs/edit/${editId}?customerid=${customerId}&proposalid=${proposalId}`;
    const postUrl = `/api/jobs/edit`;

    const schedule = scheduleOverride || ((editView) => window.location =
        `/calendar/scheduleJobAppointment?jobId=${editView.item.id}`);

    return (
        <FormLoader
            cancelEdit={cancelEdit}
            fetchData={fetchData}
            loadForm={editId !== undefined && editId !== proposalId}
            getUrl={getUrl}
            postUrl={postUrl}
            validator={areaValidator}
        >
            <EditForm
                cancelEdit={cancelEdit}
                //send fetchData so we can update jobs if 
                //we bypass the regular submit to add payments
                fetchData={fetchData}
                schedule={schedule}
            />
        </FormLoader>
    );
}

JobEditor.propTypes = {
    editId: PropTypes.number,
    customerId: PropTypes.number,
    cancelEdit: PropTypes.func,
    fetchData: PropTypes.func
};

export default JobEditor;